import { Fragment } from "react";

import logoApproved from "../assets/images/approved.jpeg";
import logoRejected from "../assets/images/rejected.jpeg";

import ComplianceLabel from "./ComplianceLabel";
import NonConformityLabel from "./NonConformityLabel";

const TicketBadge = (props) => {
    if(props.item) {
        return(
            <Fragment>
                {props.item.samplingStatus === "Closed" ? <span className="me-1 ps-1 pe-1" style={{color:"white", backgroundColor: "#228B22"}}>SAMP</span> : ""}
                {props.item.samplingStatus === "Aborted" ? <span className="me-1 ps-1 pe-1 bg-danger" style={{color:"white"}}>SAMP</span> : ""}
                {props.item.inspectionStatus === "Closed" ? <span className="me-1 ps-1 pe-1" style={{color:"white", backgroundColor: "#228B22"}}>INS</span> : ""}
                {props.item.inspectionStatus === "Aborted" ? <span className="me-1 ps-1 pe-1 bg-danger" style={{color:"white"}}>INS</span> : ""}
                <ComplianceLabel value={props.item.complianceState || ""} />
                <NonConformityLabel value={props.item.inspectionNCStateResult || ""} />
                {props.item.pdApproved === true && <span><img className="me-1" src={logoApproved} alt="" height="30" title="PD Approved" /></span>}
                {props.item.pdApproved === false && <span><img className="me-1" src={logoRejected} alt="" height="30" title="PD Rejected" /></span>}
            </Fragment>
        );
    }
    
    return "";
};

export default TicketBadge;